/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useState } from 'react'

import { Alert, AlertTitle } from '@material-ui/lab'

import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { useAppSelector } from '~/store'
import { post } from "~/tools/request";

function SellerFleetOrders() {
    const [result, setResult] = useState(null)
    const [saleIDs, setSaleIDs] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const completeSalesAPIURL = useAppSelector((state) => state.initial.endpoints.completeSalesAPIURL)
    const markSalesComplete = async () => {
        setIsSubmitting(true)
        const res = await post(completeSalesAPIURL, {
            sale_ids: saleIDs.split('\n').filter(Boolean).map(s => s.trim())
        })
        setIsSubmitting(false)
        setResult(res)
    }

    return (
        <Paper sx={{ minWidth: 800, margin: '0 auto', mt: 2.5, padding: 2.5, width: '60%' }}>
            <Stack spacing={2}>
                <Typography>{gettext('Enter sale IDs on separate lines to mark them complete')}</Typography>
                <TextField
                    id="outlined-multiline-static"
                    label={gettext('Sale IDs')}
                    multiline
                    required
                    rows={4}
                    defaultValue={saleIDs}
                    variant="outlined"
                    onChange={e => setSaleIDs(e.target.value)}
                />
                <Button variant="contained" color="primary" style={{ width: 200 }} onClick={markSalesComplete} disabled={isSubmitting}>
                    {gettext('Mark complete')}
                </Button>
                {result && 
                    <Alert severity="info">
                        <AlertTitle>{gettext('Results')}</AlertTitle>
                        <ul>
                            {result.already_complete.length > 0 && <li> {gettext('Already complete:')}  <strong>{result.already_complete.length}</strong> {gettext('orders')}</li>}
                            {result.does_not_exist.length > 0 && <li>{gettext('Does not exist:')}  <strong>{result.does_not_exist.length}</strong> {gettext('orders')}</li>}
                            <li>{gettext('Updated successfully:')}  <strong>{result.success.length}</strong> {gettext('orders')}</li>
                            <li>{gettext('Update failed:')}  <strong>{result.invalid.length}</strong> {gettext('orders')}</li>
                        </ul>
                    </Alert>
                }
            </Stack>
        </Paper>
    )
}

export default SellerFleetOrders
